import { Injectable } from '@angular/core';
import { FlagsService } from '../config/flags.service';
import { ModelLocatorService } from '../config/model-locator.service';

@Injectable({
    providedIn: 'root'
})
export class MenuService {

    constructor(private flagsService: FlagsService,
        private modelLocator: ModelLocatorService
    ) { }


    /**
     * Disables or hidden menu
     * @author Starley Cazorla
     * @param menuList
     * @returns
     */
    async disableOrHiddenMenu(menuList: any) {
        const disableOrHiddenMenu: any = this.flagsService.disable_or_hidden_menu;
        const dadosLoginIdperfil: any = this.modelLocator.dadosLogin.idperfil;

        // Verifica se a lista de menus para desabilitar ou esconder não está vazia
        if (disableOrHiddenMenu.length > 0 && dadosLoginIdperfil !== undefined) {
            // Cria um mapa de menus baseados no nome (em minúsculas) para garantir a busca eficiente
            const menuMap = new Map(disableOrHiddenMenu.map(menu => [menu.name.toLowerCase(), menu]));

            // Mapeia os itens de menu e aplica as configurações de desabilitar e esconder
            return menuList.map(item => {
                // Encontra o menu correspondente usando o nome do item
                const findMenuToApply: any = menuMap.get(item.label.toLowerCase());

                // Se encontrar o menu e o perfil for compatível, aplica as configurações
                if (findMenuToApply) {
                    // Verifica se o perfil está na lista ou se a lista está vazia
                    const shouldApplyMenu = findMenuToApply.idPerfil.length === 0 || findMenuToApply.idPerfil.includes(dadosLoginIdperfil);

                    // Aplica as configurações de ocultar/desabilitar caso as condições sejam atendidas
                    if (shouldApplyMenu) {
                        // Mescla as configurações de 'hidden' e 'disabled' com o item de menu
                        return {
                            ...item,
                            hidden: findMenuToApply.hidden,
                            disabled: findMenuToApply.disabled
                        };
                    }
                }

                // Retorna o item de menu sem alterações caso as condições não sejam atendidas
                return item;
            });
        }

        // Caso não tenha configurações ou o perfil não seja definido, retorna o menu original
        return menuList;
    }

}
